var _circle, _path, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiAmareloSlider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4741,
    cy: 10.9672,
    r: 10.2201,
    fill: "#FFCC01"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25097 14.7042C6.00508 14.6562 5.76684 14.8166 5.71884 15.0625C5.67085 15.3084 5.83127 15.5466 6.07716 15.5946L6.25097 14.7042ZM14.8641 15.6637C15.1105 15.6185 15.2736 15.3821 15.2284 15.1357C15.1832 14.8893 14.9468 14.7261 14.7004 14.7714L14.8641 15.6637ZM6.07716 15.5946C7.89505 15.9495 9.21269 16.1321 10.5225 16.1409C11.8328 16.1497 13.1159 15.9844 14.8641 15.6637L14.7004 14.7714C12.9723 15.0884 11.7543 15.2419 10.5286 15.2337C9.30235 15.2254 8.04904 15.0552 6.25097 14.7042L6.07716 15.5946Z",
    fill: "#FBFFFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.65831,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6837,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiAmareloSlider);
export default __webpack_public_path__ + "static/media/emojiAmareloSlider.1f5f4ca30e85c6044561298262eac0bc.svg";
export { ForwardRef as ReactComponent };